import { getAxiosInstance } from '../api.client';
import { type Project, type ProjectFormModel } from './projects.models';

export async function getProjects(): Promise<Project[]> {
    const response = await getAxiosInstance().get<Project[]>('/Project');
    return response.data;
}

export async function getProjectById(id: string): Promise<Project> {
    const response = await getAxiosInstance().get<Project>(`/Project/${id}`);
    return response.data;
}

export async function createProject(data: ProjectFormModel): Promise<Project> {
    const response = await getAxiosInstance().postForm<Project>(
        '/Project',
        data,
    );
    return response.data;
}

export async function updateProject(
    id: string,
    data: ProjectFormModel,
): Promise<Project> {
    const response = await getAxiosInstance().putForm<Project>(
        `/Project/${id}`,
        data,
    );
    return response.data;
}

export async function deleteProject(id: string): Promise<void> {
    await getAxiosInstance().delete(`/Project/${id}`);
}

export interface CompleteProjectRequest {
    completionDate?: string | null;
}

export async function completeProject(
    id: string,
    data?: CompleteProjectRequest,
): Promise<Project> {
    const response = await getAxiosInstance().post<Project>(
        `/Project/${id}/complete`,
        data ?? {},
    );
    return response.data;
}

export async function reactivateProject(id: string): Promise<Project> {
    const response = await getAxiosInstance().post<Project>(
        `/Project/${id}/reactivate`,
    );
    return response.data;
}
